import { render, staticRenderFns } from "./MenuItemsAdd.vue?vue&type=template&id=1a0c10cb&scoped=true"
import script from "./MenuItemsAdd.vue?vue&type=script&lang=js"
export * from "./MenuItemsAdd.vue?vue&type=script&lang=js"
import style0 from "./MenuItemsAdd.vue?vue&type=style&index=0&id=1a0c10cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c10cb",
  null
  
)

export default component.exports